import React from "react";
import { Modal, List, ListItem, ListItemText, Paper, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import EmailIcon from '@material-ui/icons/Email'
const useStyles = makeStyles((theme) => ({
	modal: {
		maxHeight: "50%",
		maxWidth: "50%",
		overflow: 'auto',
		marginLeft: "25%",
		marginTop: "10%",
	},
	root: {
		height: '100%',
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
	button: {
	}
}));

export default function (props) {
	const { patients, visible, setVisible } = props;
	const classes = useStyles();
	const handleClick = async () => {
		fetch("/send", {
			method: "POST",
			body: {
				email: "tony006469@gmail.com.tw"
			}
		}).catch((err) => {
			console.log(err)
		})
	};
	return (
		<Modal
			open={visible}
			onClose={() => setVisible(false)}
			aria-labelledby="高風險用戶"
			className={classes.modal}
		>
			<div className={classes.root}>
				<Alert severity="error">
					<AlertTitle><strong>高風險用戶</strong></AlertTitle>
					<List>
						{patients.map((item) => <ListItem>
							<ListItemText
								primary={item.lastname + item.firstname.replace(/^./, 'O')}
							/>
						</ListItem>)}
					</List>
					<div className={classes.button}>
						<Button onClick={handleClick}
							variant="contained"
							color="default"
							startIcon={<EmailIcon />}
						>
							Email通知
						</Button>
					</div>
				</Alert>
			</div>
		</Modal>
	);
}
